import React from 'react';
import { useTranslation } from 'react-i18next';
import { Home } from '@components/templates';
import { SITE_URLS } from '@constants';
import { useSEOMetatags } from '@hooks/useSEOMetatags';

export function HomePage() {
    const { t } = useTranslation();

    const translations = {
        title: t('home-page.metatags.title'),
        description: t('home-page.metatags.description'),
    };

    useSEOMetatags({
        title: translations.title,
        description: translations.description,
        url: SITE_URLS.home,
        index: true,
    });

    return <Home />;
}
